<template>
  <div class="take-over-toolbar" v-if="isShowActiveEditingUser && isDisableEditPresentation">
    <div class="take-over--editor-info">
      <div
        class="border-left"
        :class="{'bg-yellow-50': isDisableEditPresentation, 'bg-primary-90': !isDisableEditPresentation}"
      ></div>
      <aha-avatar
        class="take-over--avatar"
        :name="presentation.TakenOverByUser.name"
        :image="presentation.TakenOverByUser.avatar"
        :id="presentation.TakenOverByUser.id"
      />
      <p class="take-over--editor-text">
        <b>{{ presentation.TakenOverByUser.name }}</b>
        ({{ presentation.TakenOverByUser.email }}) is editing this presentation, you can only view it.
      </p>
    </div>
    <div class="take-over--actions">
      <aha-button
        variant="base"
        class="mr-4 -mt-1 bg-secondary-10"
        @click="openTakeOverModal()"
      >
        Take over
      </aha-button>
      <a class="font-bold text-link--primary" @click="reloadPage" v-tooltip="'Refresh to view the lastest version'">Refresh</a>
    </div>
    <TakeOverModal
      v-if="isShowTakeOverModal"
      :submitting="submitting"
      :presenting="presentation.presenting"
      @hide="closeTakeOverModal"
      @takeOver="takeover()"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PresentationApi from '@/api/presentation'
import TakeOverModal from '@/components-v2/presentation-editor/collaboration/TakeOverModal.vue'

// utils
import Utils from '@/util'

import constants from '@/constant'

export default {
  components: {
    TakeOverModal,
  },
  data() {
    return {
      submitting: false,
      isShowTakeOverModal: false,
    }
  },
  computed: {
    ...mapGetters(['isBackstage']),
    ...mapState({
      presentation: (state) => state.presentation,
      presentationEditors: (state) => state.presentationEditors,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      currentUser: (state) => state.currentUser,
    }),
    isShowActiveEditingUser() {
      if (this.isBackstage) return false
      return (this.presentation.TakenOverByUser &&
        this.presentation.TakenOverByUser.id !== this.currentUser.id)
        || (this.presentationEditors.length > 1)
    },
  },
  methods: {
    openTakeOverModal() {
      this.isShowTakeOverModal = true
      Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Open Modal')
    },
    closeTakeOverModal() {
      this.isShowTakeOverModal = false
      Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Close Modal')
    },
    async takeover() {
      this.submitting = true
      try {
        await PresentationApi.takeOver(this.presentation.id)
        Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Succeeded')
      } catch (e) {
        Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Failed')
      }

      // Looks dumb, I know. Wait 1s to synchronize with socket message to update UI properly
      setTimeout(() => {
        this.submitting = false
        this.isShowTakeOverModal = false
      }, 1000)
    },
    reloadPage() {
      Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_EDITOR, 'Collaboration > Refresh')
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
  },
}
</script>

<style lang="scss" scoped>
.take-over-toolbar {
  @apply border-b border-base-30 bg-base-0 relative flex items-center flex-grow-0 flex-shrink-0;
  width: 100%;
  padding: 12px 16px 11px;
}

.take-over--editor-info {
  @apply flex flex-row items-center flex-grow;
  padding-left: 5px;
  padding-right: 10px;
  width: 0;
}
.border-left {
  width: 5px;
  height: 28px;
  border-radius: 6px;
  margin-right: 6px;
}
.take-over--avatar {
  @apply flex-grow-0 flex-shrink-0;
}
.take-over--editor-text {
  @apply pl-2 mx-1;
  width: 100%;
  word-break: break-word;
}
.take-over--actions {
  @apply flex flex-row items-center mr-1;
}

@media (max-width: 525px) {
  .take-over-toolbar.take-over {
    display: block;
  }
  .take-over--editor-info {
    width: 100%;
    align-items: start;
  }
  .take-over--editor-text {
    @apply flex-grow;
    width: 0;
    margin-bottom: 14px;
  }
}
</style>
